import { MessageText } from "../../constants/constants.js";

const TEXT = MessageText.statusScreens.onHold;

export default function OnHoldScreen({
  sessionTitle = "this session",
  heading = TEXT.heading,
  noteLabel = TEXT.noteLabel,
  noteText = TEXT.noteText,
}) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 lg:p-8">
      <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-xl p-10 border border-blue-100">
        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center border-4 border-white shadow-inner">
            <svg className="w-10 h-10 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>

        <h2 className="text-2xl font-black text-gray-900 mb-3 tracking-tight">{heading}</h2>

        <p className="text-gray-500 text-sm mb-8 leading-relaxed">
          The session <span className="font-bold text-gray-800">"{sessionTitle}"</span> is
          currently on hold. Please stay tuned for further updates.
        </p>

        <div className="bg-blue-50 rounded-xl p-4 border border-blue-100">
          <div className="flex items-center justify-center gap-2">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" />
            <p className="text-blue-800 text-xs font-semibold uppercase tracking-widest">{noteLabel}</p>
          </div>
          <p className="text-blue-700 text-sm mt-1">{noteText}</p>
        </div>
      </div>
    </div>
  );
}
